// Redux imports
import { Provider } from "react-redux";
// import redux store so that the whole app has access to it
import store from "./store/store";

// Mui imports
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";

// Import theme for the app
import appTheme from "./styles/theme";

// Import App router
import AppRoutes from "./routes/AppRoutes";

import ReactGA from "react-ga4";

function App() {
  ReactGA.initialize("G-2GJ8PH4K4R");
  return (
    <div className="App">
      <Provider store={store}>
        <ThemeProvider theme={appTheme}>
          <CssBaseline />
          <AppRoutes />
        </ThemeProvider>
      </Provider>
    </div>
  );
}

export default App;
